import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';


import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';


// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {   
    getPracticeHeading
 } from 'Actions';

 function TabContainer({ children }) {
    return (
       <Typography component="div" style={{ padding: 8 * 3 }}>
          {children}
       </Typography>
    );
 }

class EditPSElements1 extends React.Component {
   
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    static num1 = 0;
    constructor(props) {
      
      super(props);
        this.state = {
            student: this.props.data.student,
            practdata:this.props.data.practdata,  
            activeIndex:0, 
            weekheading:'',          
        }

        
        
    } 
    
    UNSAFE_componentWillMount() {
        var student=this.state.student;
        this.props.getPracticeHeading(student, 1).then((data) => {  

            if(data.status==1){
                var resdata=data.data;
                this.setState({ 
                    weekheading:resdata[0].gph_heading 
                });
            }
        });
	}

    addHandleSubmit(event){
        event.preventDefault();
        
        var studentid=this.state.student;
        this.props.addPracticeSchedule(event,studentid);
        
    }

    handleChange(value) {
        this.setState({ activeIndex: value });
    }  

   render() {
      
      const { studentpracticelist, loading} = this.props;
     
      const styles = {
        table: {
            border: "2px solid rgb(0, 0, 0)",
            borderColor:"rgb(0 0 0 / 49%)",
            borderStyle:"solid",
            color:"#000"
        },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
        },
        tabletrtdleft:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            width:"70%"
        },
        tabletrtdhead:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight:"bold",
            textAlign:"center"
        }
    };
      return (
           <div>
               
                        <div className="row">
                            <div className="col-sm-12 col-md-10" style={{margin:"0 auto"}}>
                            <div><h3 className="text-center">{this.state.weekheading}</h3></div>
                                <div className="eachweek">   
                                                                 
                                        <Tabs
                                            value={this.state.activeIndex}
                                            onChange={(e, value) => this.handleChange(value)}                                                                                        
                                            variant="scrollable"
                                            scrollButtons="on">
                                            <Tab label="Day 1" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 2" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 3" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 4" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 5" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 6" style={{fontWeight:"bold"}}/>
                                            <Tab label="Day 7" style={{fontWeight:"bold"}}/>
                                        </Tabs>
                                        
                                    {(() => {
                                        let Fragment = [];
                                        
                                        for (let j = 1; j <=7; j++) {                                           
                                            
                                            var tablename="Day "+j;
                                            var tabval=j-1;
                                            { this.state.activeIndex === tabval && 
                                                
                                                Fragment.push(<TabContainer>
                                                    <RctCollapsibleCard heading={tablename} fullBlock>
                                                <div className="table-responsive">
                                                <table className="table align-items-center table-flush" style={styles.table}>   
                                                    <thead>
                                                        <th style={styles.tabletrtdhead}>Session</th>
                                                        <th style={styles.tabletrtdhead}>Shot</th>
                                                        <th style={styles.tabletrtdhead}>Type</th>
                                                        <th style={styles.tabletrtdhead}>Practice Drill</th>
                                                    </thead>                     
                                                    <tbody>
                                                        {(() => {
                                                                let td = [];
                                                                
                                                                for (let i = 1; i <=5; i++) {
                                                                    var nameshot="shotname_1_"+j+"_"+i;  
                                                                    var nametype="typename_1_"+j+"_"+i;
                                                                    var namedrill="edpractdrill_1_"+j+"_"+i;

                                                                    
                                                                    td.push(<tr key={i}>
                                                                            <td style={styles.tabletrtd}>{i}</td>
                                                                            <td style={styles.tabletrtd}>{this.state.practdata==1?studentpracticelist[nameshot]:''}</td>
                                                                            <td style={styles.tabletrtd}>{this.state.practdata==1?studentpracticelist[nametype]:''}</td>
                                                                            <td style={styles.tabletrtdleft}>{this.state.practdata==1?studentpracticelist[namedrill]:''}</td>
                                                                        </tr>);

                                                                 }
                                                            return td;
                                                        })()}
                                                    </tbody>
                                                </table>
                                                    
                                                </div>
                                                </RctCollapsibleCard></TabContainer>);
                                                
                                            }
                                        }
                                        return Fragment;
                                                 
                                    })()}  
                                            
                                    
                                </div>
                                
                            </div>
                        </div>
                        
                    
         </div>
      );
   }
}


const mapStateToProps = ({ practiceschedule }) => {
	const { studentpracticelist, loading } = practiceschedule;
    return { studentpracticelist, loading };
}

export default connect(mapStateToProps, {
    getPracticeHeading
})(EditPSElements1); 